
/* ===== index.html inline @line 3458 ===== */
/*<![CDATA[*/


/* ===== index.html inline @line 3460 ===== */
/*<![CDATA[*/
// removed
/*]]>*/

/* ===== index.html inline @line 3509 ===== */

(function () {
  var marketSection = document.getElementById('i185tv3al_0');
  if (!marketSection) return;

  document.querySelectorAll('[data-market-section-link]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var isExpandedMenuLink = link.classList.contains('menu-open_link');
      if (isExpandedMenuLink) {
        var menuCloseTrigger = document.getElementById('i1gygw0lf_0');
        if (menuCloseTrigger) menuCloseTrigger.click();
      }

      window.setTimeout(function () {
        var sectionTop = marketSection.getBoundingClientRect().top + window.pageYOffset;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (window.beckerLenis && typeof window.beckerLenis.scrollTo === 'function') {
          window.beckerLenis.scrollTo(marketSection, { immediate: reduceMotion });
        } else {
          window.scrollTo({
            top: sectionTop,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }
      }, isExpandedMenuLink ? 120 : 0);
    }, true);
  });
})();
